'use es6';

const DEFAULT_NAMESPACE = 'hubspot';
const HS_PLUGINS = 'hsPlugins';

// TODO: use `tinymce-utils` package once it is created
export const getNamespace = editor => {
  if (editor.settings[HS_PLUGINS] && editor.settings[HS_PLUGINS].namespaceClass) {
    return editor.settings[HS_PLUGINS].namespaceClass;
  }
  return DEFAULT_NAMESPACE;
};